import { ObjectOwnerType } from "./enums/object-owner-type";

export class ObjectOwner {

  id: number;
  firstname: string;
  lastname: string;
  birthName: string;
  birthDate: Date;
  company: string;
  propertyId: string;
  objectOwnerType: ObjectOwnerType
  determinedByAi: boolean;

}
